import { EntryTypeFieldType } from 'chaika-enums';

import { WithSubItemMenu } from '@store/abstract/WithSubItemMenu';

export interface RightContentMenuItemParams {
    title: string;
    value?: string;
    subItems: SubItemParams[];
}

interface SubItemParams {
    title: string;
    value: string;
    type: EntryTypeFieldType;
}

export class RightContentMenu extends WithSubItemMenu<RightContentMenuItemParams, SubItemParams> {}
